import { useEffect, useState } from "react";

import { AjaxResult } from "../../../../enums/ajaxResult";
import { useAuth } from "../../../../features/auth/context";
import { useApi } from "../../../useApi";

export function useUserSiteOption() {
    const [option, setOption] = useState<{ label: string; value: number }>();

    const { siteId } = useAuth();
    const { siteApi } = useApi();

    useEffect(() => {
        if (!siteId) return;
        let cancel = false;
        siteApi.getById(siteId).then((r) => {
            if (!cancel && r.result === AjaxResult.Success && r.data) {
                setOption({ label: r.data.name, value: r.data.id });
            }
        });
        return () => {
            cancel = true;
        };
    }, [siteId, siteApi]);


    return option;
}
